import { render, staticRenderFns } from "./Erp6SaleBaseSalesTeam.vue?vue&type=template&id=5c4fd492&scoped=true&"
import script from "./Erp6SaleBaseSalesTeam.vue?vue&type=script&lang=js&"
export * from "./Erp6SaleBaseSalesTeam.vue?vue&type=script&lang=js&"
import style0 from "./Erp6SaleBaseSalesTeam.vue?vue&type=style&index=0&id=5c4fd492&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4fd492",
  null
  
)

export default component.exports